import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/setuppayouts',
    name: 'Setup Payouts',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/setup-payouts')
  },
  {
    path: '/payouts',
    name: 'Payouts',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/payouts')
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/subscriptions')
  },
  {
    path: '/cardSales',
    name: 'CardSales',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/cardSales')
  },
  {
    path: "/inventory",
    name: "Inventory",
    meta: {authRequired: true},
    component: () => import ('./views/dashboards/inventory')
  },
  {
    path: '/stores',
    name: 'Stores',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/stores')
  },
  {
    path: '/merchants',
    name: 'Merchants',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/merchants')
  },
  {
    path: '/merchant-details',
    name: 'Merchants Details',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/merchant-details')
  },
  {
    path: '/payout-details',
    name: 'Payout Detail',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/payout-details')
  },
  {
    path: '/bank-requests',
    name: 'Bank Requests',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/bank-requests')
  },
  {
    path: '/inperson',
    name: 'Offline subscriptions',
    meta: {authRequired: true},
    component: () => import('./views/dashboards/inperson')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  
]
